<div class="container" id="formulario" style="margin-top: 20px; background-color: #fff; border-radius: 5px; border-color: #000; margin-bottom: 4%;">
  
    <h3>Puedes Colaborar con Astronomio haciendo una donacion!</h3>
    <h5>Por lo que sale un cafe, haces feliz una persona que esta detras de esta pagina</h5>
    <br><br>    
    <button mat-button (click)="enviar('https://www.mercadopago.com.ar/checkout/v1/redirect?pref_id=316639489-f6a28a4f-60dd-417b-bb34-be80027e8ccf')">Donar $50</button>&nbsp;&nbsp;
    <button mat-button (click)="enviar('https://www.mercadopago.com.ar/checkout/v1/redirect?pref_id=316639489-3c0174d4-0431-4de6-bffd-821eb10a5b59')">Donar $100</button>&nbsp;&nbsp;
    <button mat-button (click)="enviar('https://www.mercadopago.com.ar/checkout/v1/redirect?pref_id=316639489-6b1513ac-85c7-42b0-ac41-42a4b13e9173')">Donar $200</button>&nbsp;&nbsp;
    <button mat-button (click)="enviar('https://www.mercadopago.com.ar/checkout/v1/redirect?pref_id=316639489-1f9c468a-380d-4072-9ec1-f62b52281d05')">Donar $500</button>&nbsp;&nbsp;
    <button mat-button (click)="enviar('https://www.mercadopago.com.ar/checkout/v1/redirect?pref_id=316639489-076a0bb0-705f-4544-8de0-66fab8385d6a')">Donar $1000</button>&nbsp;&nbsp;



    <br><br>
    <div id="anuncio">
        <p>Importante:</p>
        <p>Las sumas ofrecidas son solo validas como donaciones</p>
    </div>
</div>
